export const layoutWrapper ="min-h-screen relative"
export const publicLayoutFooter ='h-6 absoulte w-full bg-green-800 px-4  bottom-0 right-0 left-0'
export const imgContainer ="hidden  md:flex justify-center items-center w-full min-h-screen "
export const img ="max-w-none w-full h-auto md:w-3/4"